export const SET_SIDEBAR_CLICK = 'SET_SIDEBAR_CLICK';
